<template>
  <section class="page-container">
    <template v-if="!isReferralRequest">
      <h1>{{productName}}</h1>
      <div class="abs-top-right">
        <v-button
          v-if="!isFina"
          gray
          @click="handlerCreateAccount">Create Account</v-button>
        <v-button
          v-if="isFina"
          icon="user-tie"
          gray
          @click="handlerSelect(2)">{{btn_refer_text}}</v-button>
        <v-button
          v-else
          icon="user-circle"
          gray
          @click="handlerSelect(1)">{{btn_text}}</v-button>
        <v-button
          v-if="productId != 22&&!isHzmb"
          gray
          @click="handlerNext(2)">Create Refer Case</v-button>
        <v-button
          gray
          @click="() => $router.back()">Previous</v-button>
        <v-button
          green
          @click="handlerNext(1)">Next</v-button>
      </div>
    <!-- <base-info-form /> -->
    </template>
    <template v-else>
      <h1>Quick Quote</h1>
      <div class="abs-top-right">
        <v-button @click="handlerBack">Back</v-button>
        <v-button
          type="primary"
          @click="handlerNext(1)">Next</v-button>
      </div>
    </template>

    <v-serviced-progress
      class="mg-b-20 mg-t-30"
      :is-fina="isFina"></v-serviced-progress>
    <housemaid-form
      v-if="productId == 12"
      ref="housemaid-form"
      :form="formData"
      @getFormData="getFormData" />
    <working-form
      v-else-if="productId == 13"
      ref="working-form"
      :form="formData"
      @getFormData="getFormData" />
    <travel-form
      v-else-if="productId == 14"
      ref="travel-form"
      :form="formData"
      @getFormData="getFormData" />
    <decoration-form
      v-else-if="productId == 15"
      ref="decoration-form"
      :form="formData"
      @getFormData="getFormData" />
    <student-form
      v-else-if="productId == 16"
      ref="student-form"
      :form="formData"
      @getFormData="getFormData" />
    <homefire-form
      v-else-if="productId == 17"
      ref="homefire-form"
      :form="formData"
      @getFormData="getFormData" />
    <personal-form
      v-else-if="productId == 18"
      ref="personal-form"
      :form="formData"
      @getFormData="getFormData" />
    <fire-form
      v-else-if="productId == 20"
      ref="fire-form"
      :form="formData"
      @getFormData="getFormData" />
    <pet-underwriting
      v-else-if="productId == 22"
      ref="pet-form"
      :form="formData"
      @getFormData="getFormData">
    </pet-underwriting>
    <template v-else>
      <el-form
        ref="form"
        :rules="rules"
        :model="formData">
        <div class="flex-sb">
          <div class="form-half">
            <template v-if="formData.class_id === 14">
              <div class="form-item">
                <span>Body Type</span>
                <el-form-item
                  ref="typ_of_bdy_id"
                  :rules="rules.typ_of_bdy_id"
                  prop="form14.typ_of_bdy_id">
                  <v-radio-group
                    v-model="formData.form14.typ_of_bdy_id"
                    :border="true"
                    :list="allOptions.typ_of_bdy" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Cylinder Capacity </span>
                <el-form-item
                  ref="engn_cpcty"
                  :rules="rules.engn_cpcty"
                  prop="form14.engn_cpcty">
                  <v-input
                    v-model="formData.form14.engn_cpcty"
                    type="number"
                    append="cc"/>
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Year of Manufacture</span>
                <el-form-item
                  ref="rgtn_yr"
                  :rules="rules.rgtn_yr"
                  prop="form14.rgtn_yr">
                  <v-select
                    v-model="formData.form14.rgtn_yr"
                    :list="allOptions.rgtn_yr" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Will the vehicle be used for commercial purpose?</span>
                <el-form-item
                  ref="usage_ind"
                  :rules="rules.usage_ind"
                  prop="form14.usage_ind">
                  <v-radio-group
                    v-model="formData.form14.usage_ind"
                    :border="true"
                    :list="allOptions.mc_usage" />
                </el-form-item>
              </div>
            </template>
            <template v-else-if="formData.class_id === 11">
              <!--              <h2>Insured Private Car </h2>-->
              <div class="form-item">
                <span>Coverage</span>
                <el-form-item
                  :rules="rules.trm_of_cvr"
                  prop="form12.trm_of_cvr">
                  <v-radio-group
                    v-model="formData.form11.trm_of_cvr"
                    :button="true"
                    :list="CarCoverTypeOptions" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Make</span>
                <el-form-item
                  ref="brand_id"
                  :rules="rules.brand_id"
                  prop="form11.brand_id">
                  <v-select
                    v-model="formData.form11.brand_id"
                    :list="allOptions11.brand"
                  />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Model</span>
                <el-form-item
                  ref="model_id"
                  :rules="rules.model_id"
                  prop="form11.model_id">
                  <v-select
                    v-model="formData.form11.model_id"
                    :list="carModelOptions"
                    @change="handleCarYearRelation" />
                </el-form-item>
              </div>
              <!-- <div class="form-item">
                <span>Body Type</span>
                <el-form-item
                  ref="typ_of_bdy_id"
                  :rules="rules.typ_of_bdy_id"
                  prop="form11.typ_of_bdy_id">
                  <v-select
                    v-model="formData.form11.typ_of_bdy_id"
                    :list="showPrivateCarBodyType"
                  />
                </el-form-item>
              </div> -->
              <div class="form-item">
                <span>Year of Manufacture</span>
                <el-form-item
                  ref="rgtn_yr"
                  :rules="rules.rgtn_yr"
                  prop="form11.rgtn_yr">
                  <v-select
                    v-model="formData.form11.rgtn_yr"
                    :list="carYearRelationList"
                    @change="handleCarRelation"
                  />
                </el-form-item>
              </div>
              <div
                v-if="!isElectric"
                class="form-item">
                <span>Cylinder Capacity</span>
                <el-form-item
                  ref="engn_cpcty"
                  :rules="rules.engn_cpcty"
                  prop="form11.engn_cpcty">
                  <v-input-select
                    v-model="formData.form11.engn_cpcty"
                    :list="carRelationList"
                    append="cc"
                    can-select
                    key-number
                    type="number"
                  />
                </el-form-item>
              </div>

              <div
                v-if="formData.form11.trm_of_cvr==2"
                class="form-item">
                <span>Vehicle Market Value (Sum Insured)</span>
                <el-form-item
                  :rules="extraRules.isrd_vl"
                  prop="form11.isrd_vl">
                  <v-input
                    v-model="formData.form11.isrd_vl"
                    type="number"
                    prepend="HK$" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>NCD</span>
                <el-form-item
                  ref="ncd_pct"
                  :rules="rules.ncd_pct"
                  prop="form11.ncd_pct">
                  <v-radio-group
                    v-model="formData.form11.ncd_pct"
                    border
                    :list="allOptions11.ncd" />
                </el-form-item>
              </div>
              <div v-show="showBenefits">
                <h2>More Benefits</h2>
                <v-checkbox-group
                  v-model="formData.form11.benefits"
                  :block="true"
                  :list="form11Benefits" />
              </div>

            </template>
            <template v-else-if="formData.class_id === 13">
              <!--              <h2>Insured Private Car </h2>-->
              <div class="form-item">
                <span>User Type</span>
                <el-form-item
                  :rules="rules.select"
                  prop="form13.cust_typ">
                  <v-radio-group
                    v-model="formData.form13.cust_typ"
                    :button="true"
                    :list="userTypeOptions" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Type of insurance</span>
                <el-form-item
                  :rules="rules.select"
                  prop="form13.type_of_ins">
                  <v-radio-group
                    v-model="formData.form13.type_of_ins"
                    :button="true"
                    :list="allOptions13.type_of_ins" />
                </el-form-item>
              </div>
              <div
                v-if="formData.form13.type_of_ins == 2"
                class="form-item">
                <span>Number of Named Driver(s)</span>
                <el-form-item
                  :rules="rules.no_of_nm_drvr"
                  prop="form13.no_of_nm_drvr">
                  <v-radio-group
                    v-model="formData.form13.no_of_nm_drvr"
                    :button="true"
                    :list="numberFourOptions"
                    @change="handlerDirvier"
                  />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>No Claims in the past 3 years?</span>
                <el-form-item
                  :rules="rules.select"
                  prop="form13.no_claim_3_year">
                  <v-radio-group
                    v-model="formData.form13.no_claim_3_year"
                    :border="true"
                    :list="yesNoOptions"
                  />
                </el-form-item>
              </div>
            </template>
            <template v-else-if="formData.class_id === 15">
              <!--              <h2>Insured Private Car </h2>-->
              <div class="form-item">
                <span>Seating Capacity (Including Driver)</span>
                <el-form-item
                  ref="no_of_seats"
                  :rules="rules.select"
                  prop="form15.no_of_seats">
                  <v-radio-group
                    v-model="formData.form15.no_of_seats"
                    :button="true"
                    :list="hzmbPersonOptions" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Optional Benefits (at least one)</span>
              </div>
              <div >
                <el-form-item
                  ref="limit_type"
                  :rules="rules.checkSelectType"
                  :show-message="false"
                  prop="form15.limit_type">
                  <v-checkbox
                    v-model="formData.form15.limit_type"
                  >機動車第三者責任險</v-checkbox>
                </el-form-item>
                <div
                  v-if="formData.form15.limit_type==1"
                  class=" mg-t-15 mg-l-25">
                  <div
                    class="form-item">
                    <span>Third Party Liability Insurance</span>
                    <el-form-item
                      ref="form15.tppd_limit_amt"
                      :rules="rules.select"
                      prop="form15.tppd_limit_amt">
                      <v-select
                        v-model="formData.form15.tppd_limit_amt"
                        :list="allOptions15.tppd_opt"
                      />
                    </el-form-item>
                  </div>
                  <div
                    v-if="formData.form15.tppd_limit_amt"
                    class="form-item">
                    <span>附加醫保外醫療費用責任險{{limit_label.name}}</span>
                    <el-form-item>
                      <v-radio-group
                        v-model="formData.form15.is_nmc_tppd_limit_amt"
                        border
                        :list="allOptions15.need_opt"
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="mg-t-15">
                <el-form-item
                  ref="plil_limit_type"
                  :rules="rules.checkSelectType"
                  :show-message="!limitVaild"
                  prop="form15.plil_limit_type">
                  <v-checkbox
                    v-model="formData.form15.plil_limit_type"
                    :is-boolean="false"
                  >機動車第三者附加醫保外醫療費用責任險</v-checkbox>
                </el-form-item>
                <div
                  v-if="formData.form15.plil_limit_type==1"
                  class="mg-t-15 mg-l-25">
                  <div
                    class="form-item">
                    <span>Vehicle Occupant Liability Insurance</span>
                    <el-form-item>
                      <v-select
                        v-model="formData.form15.plil_limit_amt"
                        :list="allOptions15.plil_opt"/>
                    </el-form-item>
                  </div>
                  <div
                    v-if="formData.form15.plil_limit_amt"
                    class="form-item">
                    <span>附加醫保外醫療費用責任險{{plill_limit_label.name}}</span>
                    <el-form-item>
                      <v-radio-group
                        v-model="formData.form15.is_nmc_plil_limit_amt"
                        border
                        :list="allOptions15.need_opt"/>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <!--              <h2>Insured Commercial Vehicle</h2>-->
              <div class="form-item">
                <span>Coverage</span>
                <el-form-item
                  :rules="rules.trm_of_cvr"
                  prop="form12.trm_of_cvr">
                  <v-radio-group
                    v-model="formData.form12.trm_of_cvr"
                    :button="true"
                    :list="CarCoverTypeOptions"/>
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Vehicle Ownership</span>
                <el-form-item
                  ref="cust_typ"
                  :rules="rules.select"
                  prop="form12.cust_typ">
                  <v-radio-group
                    v-model="formData.form12.cust_typ"
                    :button="true"
                    :list="userTypeOptions"
                    @change="handlerCustomerType"/>
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Make</span>
                <el-form-item
                  ref="brand_id"
                  :rules="rules.brand_id"
                  prop="form12.brand_id">
                  <v-select
                    v-model="formData.form12.brand_id"
                    :list="allOptions12.brand"/>
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Vehicle Type</span>
                <el-form-item
                  prop="form12.typ_of_bdy_mix_id">
                  <v-select
                    v-model="formData.form12.typ_of_bdy_mix_id "
                    :list="allOptions12.typ_of_mix" />
                </el-form-item>
              </div>
              <div
                v-if="formData.form12.typ_of_bdy_mix_id == 4"
                class="form-item">
                <span>Tonnage</span>
                <el-form-item
                  prop="form12.tonnage">
                  <v-input
                    v-model="formData.form12.tonnage"
                    append="ton"/>
                </el-form-item>
              </div>

              <div class="form-item">
                <span>Year of Manufacture</span>
                <el-form-item
                  ref="rgtn_yr"
                  :rules="rules.rgtn_yr"
                  prop="form12.rgtn_yr">
                  <v-select
                    v-model="formData.form12.rgtn_yr"
                    :list="allOptions12.rgtn_yr" />
                </el-form-item>
              </div>
              <div
                v-show="formData.form12.trm_of_cvr==2"
                class="form-item">
                <span>Vehicle Market Value (Sum Insured)</span>
                <el-form-item
                  :rules="extraRules.isrd_vl"
                  prop="form12.isrd_vl">
                  <v-input
                    v-model="formData.form12.isrd_vl"
                    prepend="HK$"
                    key-number
                  />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>NCD</span>
                <el-form-item
                  ref="ncd_pct"
                  :rules="rules.ncd_pct"
                  prop="form12.ncd_pct">
                  <v-radio-group
                    v-model="formData.form12.ncd_pct"
                    border
                    :list="allOptions12.ncd" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Will the vehicle be used by third party for carrying goods for reward?</span>
                <el-form-item
                  :rules="rules.use_carrying_profit_ind"
                  prop="form12.use_carrying_profit_ind">
                  <v-radio-group
                    v-model="formData.form12.use_carrying_profit_ind"
                    :border="true"
                    :list="yesNoOptions" />
                </el-form-item>
              </div>
              <div v-show="showBenefits">
                <h2>More Benefits</h2>
                <v-checkbox-group
                  v-model="formData.form12.benefits"
                  :block="true"
                  :list="allOptions12.benefits" />
              </div>
            </template>
          </div>
          <div
            v-if="![13].includes(formData.class_id)"
            class="form-half pd-t">
            <template v-if="formData.class_id === 14">
              <h3>Coverage Detail</h3>
              <!-- <div class="form-item">
                <span>Coverage</span>
                <el-form-item
                  ref="trm_of_cvr"
                  :rules="rules.trm_of_cvr"
                  prop="form14.trm_of_cvr">
                  <v-radio-group
                    v-model="formData.form14.trm_of_cvr"
                    :disabledList="[0, 2]"
                    :button="true"
                    :list="allCoverTypeOptions" />
                </el-form-item>
              </div> -->
              <div class="form-item">
                <span>Number of Named Driver(s)</span>
                <el-form-item
                  ref="no_of_nm_drvr"
                  :rules="rules.no_of_nm_drvr"
                  prop="form14.no_of_nm_drvr">
                  <v-radio-group
                    v-model="formData.form14.no_of_nm_drvr"
                    :button="true"
                    :list="numberTwoOptions"
                    @change="handlerDirvier" />
                </el-form-item>
              </div>
              <div
                v-for="(item,index) in formData.form14.nm_drvr_list"
                :key="'motor_14'+index">
                <span  class="form-item-title">{{'Driver'+(index+1)}}</span>
                <div class="form-item">
                  <span>Named driver age</span>
                  <el-form-item
                    :ref="'form14.nm_drvr_list.'+index+'.nm_drvr_age'"
                    :rules="rules.nm_drvr_age"
                    :prop="'form14.nm_drvr_list.'+index+'.nm_drvr_age'">
                    <v-select
                      v-model="item.nm_drvr_age"
                      :list="allOptions11.drvr_age"
                    />
                  </el-form-item>
                </div>
                <div class="form-item">
                  <span>Driving licence of Named Driver</span>
                  <el-form-item
                    :ref="'form14.nm_drvr_list.'+index+'.nm_drvr_exp'"
                    :prop="'form14.nm_drvr_list.'+index+'.nm_drvr_exp'"
                    :rules="rules.nm_drvr_exp">
                    <v-select
                      v-model="item.nm_drvr_exp"
                      :list="allOptions.drvr_exp" />
                  </el-form-item>
                </div>
                <div class="form-item">
                  <span>Driver Occupation</span>
                  <el-form-item
                    :ref="'form14.nm_drvr_list.'+index+'.nm_drvr_occ_id'"
                    :prop="'form14.nm_drvr_list.'+index+'.nm_drvr_occ_id'"
                    :rules="rules.select">
                    <v-select
                      v-model="item.nm_drvr_occ_id"
                      :border="true"
                      :list="motorOccList" />
                  </el-form-item>
                </div>
              </div>
              <div class="form-item">
                <span>NCD</span>
                <el-form-item
                  ref="ncd_pct"
                  :rules="rules.ncd_pct"
                  prop="form14.ncd_pct">
                  <v-radio-group
                    v-model="formData.form14.ncd_pct"
                    border
                    :list="allOptions.ncd" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Are all the driver(s) has not been involved in a motor accident in the past 3 years?</span>
                <el-form-item
                  :rules="rules.no_dr_acci_ind"
                  prop="form14.no_dr_acci_ind">
                  <v-radio-group
                    v-model="formData.form14.no_dr_acci_ind"
                    :border="true"
                    :list="acciOptions" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Are all the driver(s) has not been deducted driving offence points in the past 3 years?</span>
                <el-form-item
                  :rules="rules.no_dr_deduct_ind"
                  prop="form14.no_dr_deduct_ind">
                  <v-radio-group
                    v-model="formData.form14.no_dr_deduct_ind"
                    :border="true"
                    :list="deductOptions" />
                </el-form-item>
              </div>
              <div
                v-for="(item,index) in formData.form14.nm_drvr_list"
                :key="'motor'+index">
                <span
                  v-if="(formData.form14.no_dr_acci_ind===0 || formData.form14.no_dr_deduct_ind===0)&&formData.class_id==14"
                  class="form-item-title"
                >{{'Driver'+(index+1)}}</span>
                <div
                  v-if="formData.form14.no_dr_acci_ind===0&&formData.class_id==14"
                  class="form-item">
                  <span>Number of accident in last 3 years</span>
                  <el-form-item
                    :ref="'form14.nm_drvr_list.'+index+'.nm_drvr_acc'"
                    :prop="'form14.nm_drvr_list.'+index+'.nm_drvr_acc'"
                    :rules="rules.nm_drvr_acc">
                    <v-select
                      v-model="item.nm_drvr_acc"
                      :list="allOptions.accident_num" />
                  </el-form-item>
                </div>
                <div
                  v-if="formData.form14.no_dr_deduct_ind===0&&formData.class_id==14"
                  class="form-item">
                  <span>Number of driving offence point in last 3 years</span>
                  <el-form-item
                    :ref="'form14.nm_drvr_list.'+index+'.nm_drvr_pt'"
                    :prop="'form14.nm_drvr_list.'+index+'.nm_drvr_pt'"
                    :rules="rules.nm_drvr_pt">
                    <v-select
                      v-model="item.nm_drvr_pt"
                      :list="allOptions.off_points" />
                  </el-form-item>
                </div>
              </div>
            </template>
            <template v-else-if="formData.class_id === 11">
              <!-- <div class="form-item">
                <span>Coverage</span>
                <el-form-item
                  :rules="rules.trm_of_cvr"
                  prop="form11.trm_of_cvr">
                  <v-radio-group
                    v-model="formData.form11.trm_of_cvr"
                    :button="true"
                    :list="allCoverTypeOptions" />
                </el-form-item>
              </div> -->
              <div class="form-item">
                <span>Number of Named Driver(s)</span>
                <el-form-item
                  :rules="rules.no_of_nm_drvr"
                  prop="form11.no_of_nm_drvr">
                  <v-radio-group
                    v-model="formData.form11.no_of_nm_drvr"
                    :button="true"
                    :list="numberFourOptions"
                    @change="handlerDirvier"
                  />
                </el-form-item>
              </div>

              <div class="form-item">
                <span>Are all the driver(s) has not been involved in a motor accident in the past 3 years?</span>
                <el-form-item
                  :rules="rules.no_dr_acci_ind"
                  prop="form11.no_dr_acci_ind">
                  <v-radio-group
                    v-model="formData.form11.no_dr_acci_ind"
                    :border="true"
                    :list="acciOptions" />
                </el-form-item>
              </div>

              <div>
                <div
                  v-for="(item,index) in formData.form11.nm_drvr_list"
                  :key="'private'+index">
                  <span  class="form-item-title">{{'Driver'+(index+1)}}</span>
                  <div class="form-item">
                    <span>Named driver age</span>
                    <el-form-item
                      :ref="'form11.nm_drvr_list.'+index+'.nm_drvr_age'"
                      :rules="rules.nm_drvr_age"
                      :prop="'form11.nm_drvr_list.'+index+'.nm_drvr_age'">
                      <v-select
                        v-model="item.nm_drvr_age"
                        :list="allOptions11.drvr_age"
                      />
                    </el-form-item>
                  </div>
                  <div
                    v-if="formData.class_id==11"
                    class="form-item">
                    <span>Driving license </span>
                    <el-form-item
                      :ref="'form11.nm_drvr_list.'+index+'.nm_drvr_exp'"
                      :prop="'form11.nm_drvr_list.'+index+'.nm_drvr_exp'"
                      :rules="rules.nm_drvr_exp">
                      <v-select
                        v-model="item.nm_drvr_exp"
                        :list="drvr_exp_list(11)" />
                    </el-form-item>
                  </div>
                  <div
                    v-if="formData.form11.no_dr_acci_ind===0&&formData.class_id==11"
                    class="form-item">
                    <span>Number of accident in last 3 years</span>
                    <el-form-item
                      :ref="'form11.nm_drvr_list.'+index+'.nm_drvr_acc'"
                      :prop="'form11.nm_drvr_list.'+index+'.nm_drvr_acc'"
                      :rules="rules.nm_drvr_acc">
                      <v-select
                        v-model="item.nm_drvr_acc"
                        :list="allOptions.accident_num" />
                    </el-form-item>
                  </div>
                  <div
                    v-if="formData.class_id==11"
                    class="form-item">
                    <span>Number of driving offence point in last 3 years</span>
                    <el-form-item
                      :ref="'form11.nm_drvr_list.'+index+'.nm_drvr_pt'"
                      :prop="'form11.nm_drvr_list.'+index+'.nm_drvr_pt'"
                      :rules="rules.nm_drvr_pt">
                      <v-select
                        v-model="item.nm_drvr_pt"
                        :list="allOptions.off_points" />
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <span>Driver Occupation</span>
                    <el-form-item
                      :ref="'form11.nm_drvr_list.'+index+'.nm_drvr_occ_id'"
                      :prop="'form11.nm_drvr_list.'+index+'.nm_drvr_occ_id'"
                      :rules="rules.select">
                      <v-select
                        v-model="item.nm_drvr_occ_id"
                        :border="true"
                        :list="allOptions.occupation" />
                    </el-form-item>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="formData.class_id === 15">
              <div class="form-item">
                <span>No Claims Record Option</span>
                <el-form-item
                  ref="form15.ncd_opt"
                  :rules="rules.select"
                  prop="form15.ncd_opt"
                >
                  <v-select
                    v-model="formData.form15.ncd_opt"
                    :button="true"
                    :list="allOptions15.ins_opt" />
                </el-form-item>
              </div>
            </template>
            <template v-else>
              <div class="form-item">
                <span>Number of Named Driver(s)</span>
                <el-form-item
                  :rules="rules.no_of_nm_drvr"
                  prop="form11.no_of_nm_drvr">
                  <v-radio-group
                    v-model="formData.form12.no_of_nm_drvr"
                    :button="true"
                    :list="numberTwoOptions"
                    @change="handlerDirvier"
                  />
                </el-form-item>
              </div>
              <div>
                <div
                  v-for="(item,index) in formData.form12.nm_drvr_list"
                  :key="'form12'+index">
                  <span
                    class="form-item-title">Driver {{index+1}}</span>
                  <div
                    class="form-item">
                    <span>Named driver age</span>
                    <el-form-item
                      :ref="'form12.nm_drvr_list.'+index+'.nm_drvr_age'"
                      :rules="rules.nm_drvr_age"
                      :prop="'form12.nm_drvr_list.'+index+'.nm_drvr_age'">
                      <v-select
                        v-model="item.nm_drvr_age"
                        :list="allOptions12.drvr_age"
                      />
                    </el-form-item>
                  </div>
                  <div
                    class="form-item">
                    <span>Driving license </span>
                    <el-form-item
                      :ref="'form12.nm_drvr_list.'+index+'.nm_drvr_exp'"
                      :prop="'form12.nm_drvr_list.'+index+'.nm_drvr_exp'"
                      :rules="rules.nm_drvr_exp">
                      <v-select
                        v-model="item.nm_drvr_exp"
                        :list="drvr_exp_list(12)" />
                    </el-form-item>
                  </div>
                  <!--                  <div-->
                  <!--                    v-if="formData.form12.no_dr_acci_ind===0&&formData.class_id==12"-->
                  <!--                    class="form-item">-->
                  <!--                    <span>Number of accident in last 3 years</span>-->
                  <!--                    <el-form-item-->
                  <!--                      :ref="'form12.nm_drvr_list.'+index+'.nm_drvr_acc'"-->
                  <!--                      :prop="'form12.nm_drvr_list.'+index+'.nm_drvr_acc'"-->
                  <!--                      :rules="rules.nm_drvr_acc">-->
                  <!--                      <v-select-->
                  <!--                        v-model="item.nm_drvr_acc"-->
                  <!--                        :list="allOptions.accident_num" />-->
                  <!--                    </el-form-item>-->
                  <!--                  </div>-->
                  <div
                    class="form-item">
                    <span>Number of driving offence point in last 3 years</span>
                    <el-form-item
                      :ref="'form12.nm_drvr_list.'+index+'.nm_drvr_pt'"
                      :prop="'form12.nm_drvr_list.'+index+'.nm_drvr_pt'"
                      :rules="rules.nm_drvr_pt">
                      <v-select
                        v-model="item.nm_drvr_pt"
                        :list="allOptions.off_points" />
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <span>Driver Occupation</span>
                    <el-form-item
                      :ref="'form12.nm_drvr_list.'+index+'.nm_drvr_occ_id'"
                      :prop="'form12.nm_drvr_list.'+index+'.nm_drvr_occ_id'"
                      :rules="rules.select">
                      <v-select
                        v-model="item.nm_drvr_occ_id"
                        :border="true"
                        :list="allOptions.occupation" />
                    </el-form-item>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </el-form>
    </template>
    <attach-customer
      ref="attachCustomer"
      :is-motor-trade="carClassId==13"
      :is-personal="carClassId==15"
      :motor-cust-type="formData.form13.cust_typ"
      :commercial-customer-type="commercialCustType"
      :customer-type="select_type"></attach-customer>
    <div
      v-if="isDev"
      class="text-block">
      <v-button
        type="danger"
        @click="handlerText">測試數據</v-button>
    </div>
    <create-account-dialog
      v-model="createAccountDialog"
      :commercial-customer-type="commercialCustType"
      :is-commercial="isCommercial"
      :is-personal="carClassId==15"
      :is-motor-trade="carClassId==13"
      :motor-cust-type="formData.form13.cust_typ"
      :product-type="productId"></create-account-dialog>
  </section>
</template>
<script>
// import BaseInfoForm from '../components/base-info-form'
import {mapActions, mapState} from 'vuex'
import {getQuoteAll, getQuoteAllNew} from '@/api/quote'
import MixinOptions from '@/mixins/options'
import MixinFina from '@/mixins/fina'
import MixinRules from '@/mixins/rules'
import MixinCarRelation from '@/mixins/car-relation'
import HousemaidForm from './modules/housemaid/form/underwriting'
import WorkingForm from './modules/working/form/underwriting'
import StudentForm from './modules/student/form/underwriting'
import TravelForm from './modules/travel/form/underwriting'
import DecorationForm from './modules/decoration/form/underwriting'
import HomefireForm from './modules/homefire/form/underwriting'
import FireForm from './modules/homefire/form/fire-underWriting'
import PersonalForm from './modules/personal/form/underwriting'
import attachCustomer from '@/views/quoting/dialogs/attachCustomer'
import dayjs from 'dayjs'
import PetUnderwriting from '@/views/quoting/modules/pet/form/underwriting'
import MixinCreateAccount from '@/mixins/create-account'
export default {
  name: 'UnderWriting',
  components: {
    PetUnderwriting,
    HousemaidForm,
    WorkingForm,
    StudentForm,
    TravelForm,
    DecorationForm,
    HomefireForm,
    FireForm,
    attachCustomer,
    PersonalForm
  },
  mixins: [MixinOptions, MixinRules,MixinCarRelation,MixinFina,MixinCreateAccount],
  props: {
    isReferralRequest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const checkRequired = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      var reg = /^[1-9]*$/
      const { class_id } = this.formData
      const { brand_id } = this.formData.form11
      if(class_id==14 &&value<=0||!valueResult&&class_id==14) {
        callback(new Error('數值必需大於0 '))
      }else {
        let data = ''
        this.allOptions11.brand.forEach(item => {
          if (item.id == brand_id)
            data = item
        })
        if (value<=0 && data.is_motor !== 1 || !valueResult && data.is_motor !== 1) {
          callback(new Error('數值不得小於1 '))
        }else{
          if (!value)
            callback(new Error(this.$t('placeholder.input')))
        }
        callback()
      }
    }
    const checkInsured = (rule, value, callback) => {
      const { class_id } = this.formData
      if(class_id == 11 && Number(value) < 50000 && value){
        callback(new Error('數值必須不小於50,000'))
      }
      if(value === '0') {
        callback(new Error('數值必需大於0 '))
      }
      callback()
    }
    const checkSelectType = (rule, value, callback) => {
      const { class_id,form15 } = this.formData
      const { limit_type,plil_limit_type } = form15
      if(limit_type==0 && plil_limit_type==0){
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    return {
      select_type:1,
      drivers: {
        nm_drvr_age:'',
        nm_drvr_exp:'',
        nm_drvr_acc:'',
        nm_drvr_pt:'',
        nm_drvr_age_id:'',
        nm_drvr_occ_id:''
      },
      driver: {
        nm_drvr_age:'',
        nm_drvr_exp:'',
        nm_drvr_acc:'',
        nm_drvr_pt:'',
        nm_drvr_age_id:'',
        nm_drvr_occ_id:''
      },
      formData: {
        class_id: 14,
        form14: {
          trm_of_cvr: 1,
          // brand_id: '',
          typ_of_bdy_id: '',
          engn_cpcty: '',
          rgtn_yr: '',
          ncd_pct: '',
          usage_ind: '',
          no_of_nm_drvr: 1,
          nm_drvr_list:[
            {
              nm_drvr_age:'',
              nm_drvr_exp:'',
              nm_drvr_acc:'',
              nm_drvr_pt:'',
              nm_drvr_occ_id:''
            }
          ],
          // no_acci_nor_deduct: '',
          no_dr_acci_ind:'',
          no_dr_deduct_ind:'',
          enough_age_ind: '',
          nm_drvr_age: '',
          // enough_exp_ind: '',
          dr_lic_of_own: ''
        },
        form11: {
          brand_id: '',
          model_id: '',
          typ_of_bdy_id: '',
          engn_cpcty: '',
          rgtn_yr: '',
          ncd_pct: '',
          benefits: [],
          trm_of_cvr: 1,
          isrd_vl: '',
          no_of_nm_drvr: 1,
          nm_drvr_list:[
            {
              nm_drvr_age:'',
              nm_drvr_exp:'',
              nm_drvr_acc:'',
              nm_drvr_pt:'',
              nm_drvr_occ_id:''
            }
          ],
          // no_acci_nor_deduct: '',
          no_dr_acci_ind:'',
          no_dr_deduct_ind:'',
          enough_age_ind: '',
          enough_exp_ind: '',
        },
        form13: {
          cust_typ: 1,
          type_of_ins: '',
          no_claim_3_year: '',
          no_of_nm_drvr: 1,
        },
        form12: {
          brand_id: '',
          cust_typ: '',
          // typ_of_bdy_id: '',
          tonnage: '',
          typ_of_bdy_mix_id: '',
          rgtn_yr: '',
          ncd_pct: '',
          benefits: [],
          trm_of_cvr: 1,
          // no_acci_nor_deduct: '',
          no_dr_acci_ind: 1,
          no_dr_deduct_ind: '',
          isrd_vl: '',
          nm_drvr_list:[
            {
              nm_drvr_age:'',
              nm_drvr_exp:'',
              // nm_drvr_acc:'',
              nm_drvr_pt:'',
              nm_drvr_occ_id:''
            }
          ],
          // enough_age_ind: '',
          enough_exp_ind: '',
          use_carrying_profit_ind: ''
        },
        form15: {
          no_of_seats: 2,
          nmc_plil_limit_amt:0,
          plil_limit_amt:0,
          tppd_limit_amt:0,
          ncd_opt:0,
          nmc_tppd_limit_amt:0,
          is_nmc_plil_limit_amt:'',
          is_nmc_tppd_limit_amt:'',
          limit_type:0,
          plil_limit_type:0,
        },
      },
      extraRules: {
        engn_cpcty: [
          {validator: checkRequired, trigger: ['change', 'blur']}
        ],
        isrd_vl:[
          {validator: checkInsured, trigger: ['change', 'blur']}
        ],
        checkSelectType:[
          {validator: checkSelectType, trigger: ['change', 'blur']}
        ]
      }
    }
  },
  computed: {
    ...mapState('common', ['productId', 'allOptions12', 'carClassId']),
    ...mapState('quote', ['allQuote', 'quoteForm', 'carModelOptions']),
    ...mapState('account', ['customerId', 'selectCustomerData', 'referCustomerId', 'selectReferCustomerData']),
    ...mapState('errorfield', ['errorField']),
    ...mapState('coupon', ['selectCode']),
    isHzmb(){
      return this.carClassId ==15
    },
    limitVaild(){
      let {limit_type,plil_limit_type} = this.formData.form15||{}
      if(limit_type==1||plil_limit_type==1)
        return true
      return false
    },
    isCommercial() {
      return this.productId == 11 && this.carClassId == 12
    },
    commercialCustType() {
      let {cust_typ} = this.formData.form12 || {}
      return cust_typ || 0
    },
    motorOccList() {
      let {usage_ind} = this.formData.form14
      let arr = this.allOptions.occupation || []
      if (usage_ind == 2) {
        return arr.filter(item => item.is_mc_comm_use == 1)
      }
      return arr
    },
    productName() {
      if (this.productId == 11) {
        return this.getOptionName('motorClassOptions',this.carClassId)
      }
      else
        return this.getOptionName('productTypeOptions',this.productId)
    },
    showPrivateCarBodyType(){
      let arr = []
      arr = this.allOptions11.typ_of_bdy.filter(item => item.is_show)
      return arr
    },
    showBenefits() {
      if(this.formData.class_id === 11 && this.formData.form11.trm_of_cvr !== 1 ) {
        return true
      }
      if(this.formData.class_id === 12 && this.formData.form12.trm_of_cvr !== 1 ) {
        return true
      }
      return false
    },
    form11Benefits() {
      // let year = new Date().getFullYear()
      if(this.checkRgtnYr) {
        return this.allOptions11.benefits
      }
      return this.allOptions11.benefits.filter(item => {
        return item.id !== 2
      })
    },
    checkRgtnYr() {
      // 檢查是否兩年内
      // 不是兩年内的話 Benefits 需要隱藏 New For Old Cover In Year 1  選項
      let year = new Date().getFullYear()
      if(this.formData.form11.rgtn_yr) {
        return (year - this.formData.form11.rgtn_yr) < 2
      }
      return false
    },
    isForm12Driver(){
      let {form12,class_id} =this.formData||{}
      let { no_dr_acci_ind, no_dr_deduct_ind,enough_age_ind,enough_exp_ind} = form12||{}
      return no_dr_acci_ind&&no_dr_deduct_ind&&enough_age_ind&&enough_exp_ind&&class_id==12
    },
    isForm11Driver(){
      let {form11,class_id} =this.formData||{}
      let { no_dr_acci_ind, no_dr_deduct_ind,enough_age_ind,enough_exp_ind} = form11||{}
      return no_dr_acci_ind&&no_dr_deduct_ind&&enough_age_ind&&enough_exp_ind&&class_id==11
    },
    drvr_exp_list(){
      return index=>{
        let drvr_list = []
        if(index==11)
        {
          let {drvr_exp=[]} = this.allOptions11||{}
          drvr_list = drvr_exp||[]
        }else{
          let {drvr_exp=[]} = this.allOptions12||{}
          drvr_list = drvr_exp||[]
        }
        drvr_list = drvr_list.filter(item=>item.is_show==1)
        return drvr_list
      }
    },
    isElectric(){
      let list = this.carModelOptions||[]
      let {form11} = this.formData||{}
      let {model_id} = form11||{}
      let arr = []
      let obj = {}
      if(model_id){
        arr = list.filter(item=>item.id==model_id)
      }
      obj = arr.length>0?arr[0]:{}
      return obj.is_electric_car==1||false
    },
    showForm12MarketValue(){
      if(this.formData.form12.rgtn_yr){
        return this.formData.form12.rgtn_yr > 2011
      }
      return true
    },
    isTL() {
      let {typ_of_bdy_mix_id} = this.formData.form12 || {}
      return [9,8,10].includes(typ_of_bdy_mix_id)
    },
    isCR(){
      let {typ_of_bdy_mix_id} = this.formData.form12 || {}
      return [7].includes(typ_of_bdy_mix_id)
    },
    plill_limit_label(){
      let {plil_limit_amt}= this.formData.form15||{}
      let {nmc_plil_opt=[]} = this.allOptions15
      let result = {}
      result = nmc_plil_opt.find(item=>item.condition===plil_limit_amt)||{}
      return result
    },
    limit_label(){
      let {tppd_limit_amt}= this.formData.form15||{}
      let {nmc_tppd_opt=[]} = this.allOptions15
      let result = {}
      result = nmc_tppd_opt.find(item=>item.condition===tppd_limit_amt)||{}
      return result
    },
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        // this.updateAllOptions()
        // this.updateAllOptions(11)
        // this.updateAllOptions(12)
      }
    },
    'formData.form11.brand_id': {
      immediate: true,
      deep: true,
      handler(val, old) {
        if(val !== '' && val !== old) {
          this.updateCarModelOptions({
            val,
            time: new Date().getTime()
          })
        }
      }
    },
    carClassId:{
      immediate:true,
      handler(val){
        if(val){
          this.formData.class_id = val
        }
      }
    },
    quoteForm: {
      immediate: true,
      async handler(form) {
        // this.$nextTick(()=>{
        if(form) {
          if(Number(this.productId) !== 11) {
            this.formData = Object.assign(this.formData, form)
          }
          else {
            this.formData.class_id = form.class_id
            Object.assign(this.formData[`form${this.quoteForm.class_id}`], form)
            if(form.class_id==15){
              let {tppd_limit_amt,plil_limit_amt,nmc_tppd_limit_amt,nmc_plil_limit_amt} = form||{}
              this.formData.form15.limit_type = tppd_limit_amt>0?1:0
              this.formData.form15.plil_limit_type = plil_limit_amt>0?1:0
              this.formData.form15.is_nmc_tppd_limit_amt = nmc_tppd_limit_amt>0?1:0
              this.formData.form15.is_nmc_plil_limit_amt = nmc_plil_limit_amt>0?1:0
            }

            await  this.handleCarYearRelation()
            this.formData[`form${this.quoteForm.class_id}`].rgtn_yr = form.rgtn_yr
            await this.handleCarRelation()
          }
        }
        // })
      }
    },
    errorField:{
      immediate:true,
      deep:true,
      handler(val){
        if(val)
        {
          this.errScrollToValidDom(val)

        }
      }
    },
    'formData.form12.typ_of_bdy_mix_id':{
      immediate: true,
      handler(val) {
        if(val != 4){
          this.formData.form12.tonnage = ''
        }
      }
    },
    'formData.form11.isrd_vl':{
      immediate: true,
      handler(val){
        if(val){
          this.formData.form11.trm_of_cvr = 2
        }else{
          this.formData.form11.trm_of_cvr = 1
        }
      }
    },
    showForm12MarketValue:{
      handler(val){
        if(!val){
          this.formData.form12.isrd_vl = ''
        }
      }
    },
    'formData.form12.isrd_vl':{
      immediate: true,
      handler(val){
        if(val){
          this.formData.form12.trm_of_cvr = 2
        }else{
          this.formData.form12.trm_of_cvr = 1
        }
      }
    },
    limitVaild:{
      immediate: true,
      handler(val){
        if(val){
          this.$refs.form.clearValidate(['limit_type','plil_limit_type'])
        }
      }
    }
  },
  created() {
    // if(this.quoteForm) {
    //   if(this.productId !== 11) {
    //     this.formData = Object.assign(this.formData, this.quoteForm)
    //   }
    //   else {
    //     this.formData.class_id = this.quoteForm.class_id
    //     Object.assign(this.formData[`form${this.quoteForm.class_id}`], this.quoteForm)
    //   }
    // }
    this.setCode(null)
    this.setReferrerData(null)
  },
  methods: {
    ...mapActions('quote', ['setAllQuote', 'setQuoteForm', 'setCopyQuoteForm', 'setQuoteResult', 'updateCarModelOptions', 'setCode']),
    ...mapActions('common', ['updateAllOptions']),
    ...mapActions('coupon', ['setReferrerData', 'setSelectCode']),
    ...mapActions('account', ['setSelectCustomerData', 'setCustomerId']),
    // limit_label(name,otp_name){
    //   let form15= this.formData.form15||{}
    //   let arr = this.allOptions15[otp_name]||[]
    //   let result = {}
    //   result = arr.find(item=>item.condition===form15[name])||{}
    //   return result
    // },
    handlerCustomerType() {
      if (!this.isFina) {
        this.setCustomerId(null)
        this.setSelectCustomerData(null)
      }
    },
    handlerDirvier() {
      let {class_id} = this.formData
      let {no_of_nm_drvr, nm_drvr_list} = this.formData['form' + class_id]
      // let obj = JSON.parse(JSON.stringify(this.drivers))
      if (nm_drvr_list.length < no_of_nm_drvr) {
        for (var i = nm_drvr_list.length; i < no_of_nm_drvr; i++) {
          let obj = JSON.parse(JSON.stringify(this.drivers))
          let objData = JSON.parse(JSON.stringify(this.driver))
          if (class_id == 12 || class_id == 11)
            nm_drvr_list.push(objData)
          else
            nm_drvr_list.push(objData)
        }
      }else {
        nm_drvr_list.splice(no_of_nm_drvr,nm_drvr_list.length)
      }
    },
    handlerBack() {
      this.$emit('back')
    },
    handlerText() {
      Object.assign(this.formData.form14, {
        trm_of_cvr: 1,
        brand_id: 2,
        typ_of_bdy_id: 20,
        engn_cpcty: 200,
        rgtn_yr: 2020,
        ncd_pct: '10',
        no_acci_nor_deduct: '',
        usage_ind: 1,
        no_of_nm_drvr: 1,
        enough_age_ind: 1,
        // enough_exp_ind: 1
        dr_lic_of_own: 0
      })
      Object.assign(this.formData.form11, {
        brand_id: 125,
        model_id: 12747,
        typ_of_bdy_id: 2,
        engn_cpcty: '200',
        rgtn_yr: 2020,
        ncd_pct: 20,
        benefits: [],
        trm_of_cvr: 1,
        no_acci_nor_deduct: '',
        isrd_vl: '5000',
        no_of_nm_drvr: 1,
        enough_age_ind: 1,
        enough_exp_ind: 1,
      })
      Object.assign(this.formData.form12, {
        brand_id: 208,
        // typ_of_bdy_id: 24,
        tonnage: '',
        rgtn_yr: 2020,
        ncd_pct: 10,
        benefits: [],
        trm_of_cvr: 0,
        isrd_vl: '5000',
        no_acci_nor_deduct: '',
        no_of_nm_drvr: 1,
        enough_age_ind: 1,
        enough_exp_ind: 1,
        use_carrying_profit_ind: 1
      })
    },
    getFormData(form) {
      let params = {
        customer_id: this.customerId,
        ...form
      }
      if(this.type==2)
      {
        this.setQuoteForm(params)
        this.$emit('refer')
        this.$router.push({
          path:`/quoting/${this.severType}/refer`,
          query: {
            product_id: this.productId,
            ...this.$route.query
          }
        })
      }
      else{
        this.network().getQuoteAllNew(params)
      }

    },
    handlerNext(type) {
      this.type=type
      const formKey = {
        12: 'housemaid-form',
        13: 'working-form',
        14: 'travel-form',
        15: 'decoration-form',
        16: 'student-form',
        17: 'homefire-form',
        18: 'personal-form',
        20: 'fire-form',
        22: 'pet-form',
      }
      if(this.productId != 11) {
        this.$refs[formKey[this.productId]].submitForm()
      }
      else {
        this.$refs.form.validate(valid => {
          if(valid) {
            if(this.formData.class_id === 11) {
              // 處理 benefits
              const index = this.formData.form11.benefits.indexOf(2)
              if(index !== -1 && !this.checkRgtnYr) {
                this.formData.form11.benefits.splice(index, 1)
              }
              if(this.formData.form11.rgtn_yr <= 2011){
                this.formData.form11.trm_of_cvr = 1
              }
            }
            let {form15} = this.formData||{}
            if(this.formData.class_id==15)
            {
              let {is_nmc_tppd_limit_amt,is_nmc_plil_limit_amt,plil_limit_amt,tppd_limit_amt} = form15
              if(is_nmc_tppd_limit_amt)
              {
                this.formData.form15.nmc_tppd_limit_amt = this.limit_label.id
              }
              if(is_nmc_plil_limit_amt)
              {
                this.formData.form15.nmc_plil_limit_amt = this.plill_limit_label.id
              }
            }
            let params = {
              class_id: this.formData.class_id,
              customer_id: this.customerId,
              ...this.formData[`form${this.formData.class_id}`]
            }

            // if(this.isForm12Driver){
            //   delete params.nm_drvr_list
            // }
            let {class_id,enough_age_ind,nm_drvr_list=[]} = params||{}
            if(class_id==11&&enough_age_ind==2){
              if(nm_drvr_list.length>0){
                nm_drvr_list.forEach(item=>{
                  item.nm_drvr_age =''
                })
              }
            }
            if(type==2)
            {
              this.setQuoteForm(params)
              this.$emit('refer')
              if(this.productId==22){
                this.$ConfirmBox({
                  isNewConfirm:true,
                  width:500,
                  confirmBtn:'Done',
                  message: 'We cannot find any plans that match with your request at the moment. Thank you for supporting HoldCover!',
                }).then(() => {
                })
              }
              else {
                this.$router.push({
                  path:`/quoting/${this.severType}/refer`,
                  query: {
                    product_id: this.productId
                  }
                })
              }
            }
            else{
              let {nm_drvr_list,copy} = this.quoteForm||{}
              // if(copy==1) {
              //   params.nm_drvr_list = {...params.nm_drvr_list,...nm_drvr_list}
              // }
              this.network().getQuoteAllNew(params)
            }
          }
        })
      }
    },
    handlerSelect(type){
      this.select_type = type
      this.$refs.attachCustomer.showAttachCustomer()
    },
    radioChange(){
      this.$refs['form'].resetFields()
    },
    handler() {
      return {
        checkData: data => {
          const filterData =  data.filter(item => {
            if(item.is_refer_case === 0 && item.is_error_case === 0) {
              return item
            }
          })
          return filterData.length > 0? true: false
        }
      }
    },
    network() {
      return {
        // 采用新版報價接口
        getQuoteAllNew: async (params) => {
          if(this.selectCode && this.selectCode.coupon){
            Object.assign(params,{'coupon_code':this.selectCode.coupon.coupon_code})
          }
          let {copy,have_quo,benefits,code,coupon_code,referrer} = this.quoteForm||{}
          let {id} = referrer||{}
          if(copy==1){
            params = {
              benefits:benefits,
              ...params
            }
            let select_params ={}
            if(code)
            {
              select_params.code ={
                code,
                selectCode:2,
                referrer_user_id:id
              }
            }
            if(coupon_code){
              select_params.coupon ={
                coupon_code,
                selectCode:1
              }
              select_params.selectCode = 1
              select_params.coupon_code = coupon_code
            }
            this.setSelectCode(select_params)
          }
          let {nm_drvr_list=[],class_id,pcy_cmnt_dt} = params||{}
          let today =this.today()
          if(pcy_cmnt_dt)
          {
            let isBefore = dayjs(pcy_cmnt_dt).isBefore(today)
            if(isBefore){
              delete params.pcy_cmnt_dt
              delete params.pcy_expry_dt
            }
          }
          if([11,12].includes(class_id))
          {
            let arr = nm_drvr_list.filter(item=>item.nm_drvr_pt!=0)||[]
            let arr_exp = nm_drvr_list.filter(item=>item.nm_drvr_exp!=40)||[]
            params.no_dr_deduct_ind = arr.length>0?0:1
            params.enough_exp_ind = arr_exp.length>0?0:1
          }
          if(class_id==12){
            if(this.isTL){
              params.benefits = Array.from(new Set([64,...params.benefits]))
            }
            if(this.isCR){
              params.benefits = Array.from(new Set([256,...params.benefits]))
            }
            if(!this.isCR&&!this.isTL)
              params.benefits = params.benefits.filter(item=>![64,256].includes(item))
          }
          if(this.isFina){
            params.referrer_id=this.referCustomerId
            params.merchant_platform = 2
          }
          const { data } = await getQuoteAllNew(params)
          if(copy==1)
          {
            this.setCopyQuoteForm(this.quoteForm)
            this.setQuoteForm({
              // ... this.quoteForm,
              ...params,
              copy
            })

          }else {
            this.setCopyQuoteForm(null)
            this.setQuoteForm({
              ...params,
              is_electric_car: this.isElectric
            })
          }

          if(!data.list || data.list.length < 1) {
            if(this.isReferralRequest) {
              this.$emit('refer')
              return
            }

            this.$router.push({
              path:`/quoting/${this.severType}/refer`,
              query: {
                product_id: this.productId,
                ...this.$route.query
              }
            })
            return
          }

          this.setAllQuote(data.list)
          this.setQuoteResult(data)

          if(this.isReferralRequest) {
            this.$emit('success')
            return
          }
          this.$router.push({
            path: `/quoting/${this.severType}/quote`,
            query: {
              product_id: this.productId,
              ...this.$route.query
            }
          })
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container {
    position: relative;
    padding-bottom: 100px;
    .pd-t {
      padding-top: 20px;
    }
  .form-item-title{
      display: block;
      padding-bottom: 5px;
      font-size: 14px;
      font-weight: 500;
      color: #616266;
    }
  .red-tip{
    color:  #f56c6c;
  }
  h1{
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
  }
}
</style>
